import { Col, Collapse, DatePicker, Form, InputNumber, Row, Select } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker';
import moment from 'moment';
import React, { Dispatch, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import ClearFilterBtn from '../../../../../../components/ClearFilterBtn';
import CollapseFilter from '../../../../../../components/CollapseFilter';
import FilterBtn from '../../../../../../components/FilterBtn';
import FilterContainer from '../../../../../../components/FilterContainer';
import { SelectCidade } from '../../../../../../components/_REFACTORED/SelectCidade';
import TextFilter from '../../../../../../components/TextFilter';
import CollapseTitle from '../../../../../../components/TitleCollapseFilter';
import { ApplicationState } from '../../../../../../store';
import {
  cleanStateColetaNoCd,
  filterColetaCD,
  loadRequest,
} from '../../../../../../store/ducks/coletaNoCd/actions';
import { ROLE } from '../../../../../../utils/roles';

import { SelectParceirosTransportadoras } from '../../../../../../components/_REFACTORED/SelectParceirosTransportadoras';
import { SelectTransportadoraParceira } from '../../../../../../components/_REFACTORED/SelectTransportadoraParceira';
import { SelectParceiro } from '../../../../../../components/_REFACTORED/SelectParceiro';
import { SelectEstado } from '../../../../../../components/_REFACTORED/SelectEstado';

const Filter: React.FC = () => {
  const { Panel } = Collapse;
  const dispatch = useDispatch<Dispatch<Action>>();
  const { RangePicker } = DatePicker;

  const parceiros = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const codCdd = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const pagCurrent = useSelector((state: ApplicationState) => state.ColetaNoCd.pagination.current);
  const sorter = useSelector((state: ApplicationState) => state.ColetaNoCd.sorter);
  const perfil = useSelector((state: ApplicationState) => state.auth?.user?.perfil);
  const filter = useSelector((state: ApplicationState) => state.ColetaNoCd.filter);
  const [codEstado, setCodEstado] = useState<number | undefined>(undefined);
  const [codCidade, setCodCidade] = useState<number | undefined>(undefined);
  const [pedido, setPedido] = useState('');

  const clearFilter = () => {
    localStorage.removeItem(window.location.pathname + `valuesFilter`);
    localStorage.removeItem(`responseClientesFilter${window.location.pathname}`);
    localStorage.removeItem(`responseTransportadorasFilter${window.location.pathname}`);
    localStorage.removeItem(`responseEstadosFilter${window.location.pathname}`);
    localStorage.removeItem(`responseCidadesFilter${window.location.pathname}`);
    setCodCidade(undefined);
    setCodEstado(undefined);

    dispatch(cleanStateColetaNoCd());
    dispatch(loadRequest(undefined, parceiros, codCdd?.codCdd as number));
  };

  const onFilter = (values: any): void => {
    let [dataInicio, dataFim] = values.dhAgendamento
      ? values.dhAgendamento
      : [undefined, undefined];
    if (values.dhAgendamento) {
      dataInicio = moment(dataInicio).format();
      dataFim = moment(dataFim).format();
      values = { ...values, dataInicio, dataFim };
    }

    values.codCidade = codCidade;
    values.nuNota = values.nuNota?.map((item: string) => Number(item));

    Object.keys(values).forEach((key) => {
      if (values[key] === undefined || values[key] === null || values[key] === '') {
        delete values[key];
      }
    });

    localStorage.setItem(
      window.location.pathname + 'valuesFilter',
      JSON.stringify({ ...filter, ...values })
    );

    dispatch(filterColetaCD({ ...filter, ...values }));
  };

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    return current && current > moment().endOf('day');
  };

  const searchPedido = (value: string) => {
    const onlyNumber = value.replace(/\D/g, '');
    setPedido(onlyNumber);
  };

  return (
    <CollapseFilter
      filter={filter}
      pagination={pagCurrent}
      sorter={sorter}
      loadRequest={loadRequest}
      saveFilter={filterColetaCD}
      saveLocalStorage={'persist:ColetaNoCd'}
    >
      <Panel header={<CollapseTitle>Filtro</CollapseTitle>} key="1">
        <FilterContainer onFilter={onFilter}>
          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Pedido</TextFilter>} name="nuNota">
                <Select
                  mode="tags"
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  placeholder="Pesquise por um ou mais números"
                  onSearch={searchPedido}
                  searchValue={pedido}
                  onChange={() => setPedido('')}
                />
              </Form.Item>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Nota fiscal</TextFilter>} name="nuNotaEmitida">
                <InputNumber
                  type="number"
                  style={{ width: '100%' }}
                  min={0}
                  placeholder="Digite o número da nota fiscal"
                />
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              {perfil === ROLE.TRANSPORTADORA ? (
                <SelectParceirosTransportadoras />
              ) : (
                <SelectParceiro />
              )}
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectTransportadoraParceira />
            </Col>
          </Row>

          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <Form.Item
                label={<TextFilter>Data de emissão do pedido</TextFilter>}
                name="dhAgendamento"
              >
                <RangePicker disabledDate={disabledDate} style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectEstado setCodEstado={setCodEstado} />
            </Col>
            <Col md={6} sm={24} xs={24}>
              <SelectCidade codUf={codEstado} setCodCidade={setCodCidade} />
            </Col>
          </Row>
          <Row gutter={24} justify="end">
            <Col md={6} sm={24} xs={24}>
              <ClearFilterBtn onClick={clearFilter}>Limpar filtros</ClearFilterBtn>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <FilterBtn>Filtrar</FilterBtn>
            </Col>
          </Row>
        </FilterContainer>
      </Panel>
    </CollapseFilter>
  );
};

export default Filter;
